import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Response, Service } from '../models/service';

@Injectable({
  providedIn: 'root'
})
export class BankingReportService extends Service<any> {

  protected override URL: string = `${environment.url}`;

  constructor(protected override httpClient: HttpClient) { 
    super(httpClient);
  }

  getReportRevenueProfessional(filter: string = '') {
    return this.httpClient.get(`${environment.url}/graph/monthly/split/professional/amount${filter}`)
                          .pipe(map((res: any) => res["hydra:member"]));
  }

  getReportRevenueClinic(filter: string = '') {
    return this.httpClient.get(`${environment.url}/graph/monthly/split/clinic/amount${filter}`)
                          .pipe(map((res: any) => res["hydra:member"]));
  }

  getReportBillingMachineProfessional(filter: string = '', contentType: 'application/json' | 'text/csv' = 'application/json') {
    let params: any = {};
    if(contentType === 'text/csv') { 
      params = { responseType: 'blob',  headers: { 'Accept': contentType } };
    }
    return this.httpClient.get(`${environment.url}/machine/order/report${filter}`, params).pipe(
                map((res: any) => new Response<any>(
                    res["hydra:member"] || res,
                    res["hydra:view"],
                    res["hydra:totalItems"],
                    this
                ))
            ) as Observable<Response<any>>;
  }

  getReportBillingMachineUnit(filter: string = '', contentType: 'application/json' | 'text/csv' = 'application/json') {
    let params: any = {};
    if(contentType === 'text/csv') { 
      params = { responseType: 'blob',  headers: { 'Accept': contentType } };
    }
    return this.httpClient.get(`${environment.url}/machine/order/report${filter}`, params).pipe(
      map((res: any) => new Response<any>(
          res["hydra:member"] || res,
          res["hydra:view"],
          res["hydra:totalItems"],
          this
          ))
      ) as Observable<Response<any>>;
  }


  getReportBalance(recipient: string) {
    return this.httpClient.get(`${environment.nami_url}/pagarme/extract/${recipient}`)
  }

  getReportSplitBalance(recipient: string) {
    let date = new Date();
    return this.httpClient.get(`${environment.nami_url}/pagarme/extract/${recipient}/month/${date.getMonth() + 1}/year/${date.getFullYear()}`)
  }
}
